<template>
  <div>
    <session-registration
      v-if="session"
      :session="session"
      :profile="profile"
      :theme="null"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SessionRegistration from "@/components/common/sessionComponents/sessions/registrationStandard";
import RecordViews from "@/mixins/RecordViews";

export default {
  name: "Session_Registration",
  mixins: [RecordViews],
  components: {
    SessionRegistration
  },
  created() {
    this.getProfile();
  },
  beforeMount() {
    this.cornerTitle = this.$route.params.cornerTitle;
    this.resourcePath = this.$route.params.resource;
    this.resourceItemPath = this.$route.params.resourceItem;

    if (this.resourcePath) {
      console.log(
        `Title: ${this.cornerTitle} | Resource: ${this.resourcePath} | ResourceItem: ${this.resourceItemPath} `
      );
    }
  },
  mounted() {
    this.getSessionData();
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      profile: "user/profile"
    }),
    session() {
      return this.sessionData && this.sessionData.doc
        ? this.sessionData.doc
        : null;
    }
  },
  methods: {
    getProfile() {
      this.$store
        .dispatch("user/getProfile")
        .then(() => {
          this.$nprogress.done();
        })
        .catch(error => {
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    handleNoCornerData() {
      this.$router.push("/");
    },
    getSessionData() {
      this.$store
        .dispatch("listings/getSessionByTitle", this.cornerTitle)
        .then(res => {
          if (Object.keys(res).length === 0) {
            this.handleNoCornerData();
          } else {
            this.sessionData = res;
            this.recordView(this.sessionData.id);
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    recordView(sessionId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "sessions",
        entityId: sessionId,
        feedbackType: "views",
        sessionId: this.checkSession("sessions")
      });
    },
    handleToggleShelfSession(data) {
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (!this.isFollowed) {
          this.$store
            .dispatch("user/followBlogger", this.session.blogger)
            .then(() => {
              this.getCollectedCornerSessions();
              console.log("Followed");
            });
        } else {
          this.$store
            .dispatch("user/unfollowBlogger", this.session.blogger)
            .then(() => {
              this.getCollectedCornerSessions();
              console.log("Unfollowed");
            });
        }
      }
    }
  },
  watch: {
    profile(val) {
      return val;
    }
  },
  metaInfo() {
    return {
      title: "JourneyBinder Blog",
      meta: [
        // Twitter Card
        { name: "twitter:title", content: this.blogTitle },
        { name: "twitter:card", content: "Our Blog Page" },
        { name: "twitter:description", content: this.description },
        { name: "twitter:image", content: this.logo },
        { property: "og:title", content: this.blogTitle },
        { property: "og:site_name", content: "HeartBeatFam" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        { property: "og:description", content: this.description }
      ]
    };
  },
  data() {
    return {
      resource: {
        //@ToDo- comes from publishing
        toolId: "1goNyf7FPZre0yOJU2Vx",
        name: "Sessions"
      },
      sessionData: null,
      cornerTitle: null,
      resourcePath: null,
      resourceItemPath: null,
      collectedCorners: null
    };
  }
};
</script>
